import DialogActions from "./DialogActions";

export default DialogActions;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/dialog/DialogActions/index.js